import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';
import { useIconMaskId } from './useIconMaskId';

export function ContentToolsIcon(props: ToolIconProps) {
  const maskId = useIconMaskId('content-tools');

  return (
    <ToolIconFrame {...props}>
      <defs>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="48"
        >
          <rect width="48" height="48" fill="#fff" />
          <path
            d="M26 40L31.66 38.58L41.55 28.69L37.31 24.45L27.42 34.34Z"
            fill="#000"
            stroke="#000"
            strokeWidth="7"
            strokeLinejoin="round"
          />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <rect
          x="5"
          y="5"
          width="30"
          height="38"
          rx="5"
          fill="none"
          stroke={toolIconPrimary}
          strokeWidth="3"
        />
      </g>
      <path
        d="M12 16H28M12 23H28M12 30H19"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 40L31.66 38.58L41.55 28.69L37.31 24.45L27.42 34.34Z"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
